export default __webpack_public_path__ + "static/media/17.8623a5b1.png";